import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n.use(initReactI18next).init({
    resources: {
        en: {
            translation: {
                "dashboard": "Dashboard",
                "animals": "Animals",
                "customers": "Customers",
                "billing": "Billing",
                "addAppointment": "Add appointment",
                // DayView Component
                "cancelBooking": "Cancel Booking",
                "confirmCancellation": "Are you sure you want to cancel this booking?",
                "confirmEditReservation": "You are about to edit this reservation.",
                "checkIn": "Check-in",
                "checkOut": "Check-out",
                "owner": "Owner",
                "veterinarian": "Veterinarian",
                "actions": "Actions",
                "updateReservationHours": "Update reservation hours",
                "download_contracts": "Download contracts",
                "validate": "Remove from overview",
                "yes": "Yes",
                "no": "No",
                "save": "Save",
                "cancel": "Cancel",
                "confirm": "Confirm",
                "removeThisTemplate": "Remove this template",
                "templateRemoved": "Template removed",
                "contractTemplateSaved": "Contract template saved",
                "saveFirstForPdfPreview": "Save first to open a PDF preview.",
                "pdfPreviewFailed": "Failed to generate PDF preview",
                "imageUrlPrompt": "Image URL (https://...):",
                "invalidImageUrl": "Use a valid http(s) URL (or data:image/...)",
                "pageBreak": "Page break",
                "insertPlaceholderAtCursor": "Insert placeholder",
                "atCursor": "At cursor:",
                "insertNewPageAtCursor": "Insert new page",
                "pdfPreview": "PDF Preview",
                "previewValues": "Preview Values",
                "editClientContract": "Edit Client Contract",
                "removeFailed": "Remove failed",
                "ignoreChanges": "Ignore changes",
                "fillAllRequiredFields": "Fill all required fields",
                "areYouSureYouWantToRemoveThisStay": "Are you sure you want to remove this stay?",
                "editAppointment": "Edit Appointment",
                "editReservation": "Edit Reservation",
                "updateReservationFailed": "Failed to update reservation",
                "updatedReservationSuccessful": "Reservation successfully updated",
                "photoSaved": "Photo saved",
                "uploadFailed": "Upload failed",
                "photoOf": "Photo of {{name}}",
                "chooseFile": "Choose file",
                "chooseAnotherFile": "Choose another file",
                "clickToUpload": "Click to upload",
                "uploading": "Uploading...",
                "invalidFileType": "Invalid file type. Choose JPG, PNG or WebP.",
                "fileTooLarge": "File is too large. Maximum is 5 MB.",
                "uploadPhoto": "Upload photo",
                "changePhoto": "Change photo",

                // New Component
                "enterCatName": "Enter your cat's name",
                "catInfo": "Information about {{{name}}}",
                "name": "Name",
                "birthDate": "BirthDate",
                "breed": "Breed",
                "sex": "Sex",
                "male": "Male",
                "female": "Female",
                "unknown": "Unknown",
                "color": "Color",
                "chipNumber": "Chip Number",
                "medicalInfo": "Medical information of {{name}}",
                "neutered": "Spayed/Neutered",
                "dewormed": "Dewormed & Flea Treated",
                "leukemia": "Cat Leukemia (leucose)",
                "panleukopenia": "Panleukopenia (panleucopenie / typhus)",
                "coryza": "Coryza",
                "behavior": "Behavior of {{name}}",
                "basicInfo": "Basic information",
                "healthSection": "Health of {{name}}",
                "behaviorSection": "Behavior of {{name}}",
                "contactsSection": "Contacts",
                "reservationsSection": "Reservations",
                "appointmentsSection": "Appointments",
                "pastAppointments": "Past appointments",
                "upcomingAppointments": "Upcoming appointments",
                "appointmentFor": "Appointment for",
                "associationAnimals": "Interaction with other animals",
                "noUpcomingAppointments": "No upcoming appointments",
                "noPastAppointments": "No past appointments",
                "pastReservations": "Past reservations",
                "noPastReservations": "No past reservations",
                "noReservationsFound": "No reservations found",
                "noAppointmentsFound": "No appointments found",
                "homeBehavior": "Home Behavior",
                "diet": "Diet",
                "medicalHistory": "Medical history",
                "interactionWithAnimals": "Interaction with Other Animals",
                "interactionWithAnimalsPlaceholder": "Interaction with Other Animals",
                "allowContact": "May interact with other cats in the play area",
                "vaccinationRequiredTooltip": "Required vaccination for a stay at {{tenantName}}",
                "vaccinationWarning": "Vaccinations are mandatory for staying at {{tenantName}} and will be checked at check-in. If vaccinations are incomplete, your cat will be denied entry.",
                "previous": "Previous",
                "next": "Next",
                "update": "Update",
                "fillData": "Fill in the information for {{name}}",
                "submit": "Submit",
                "loginPrompt": "Log in to make a reservation.",
                "backToTenant": "Back to {{tenantName}}",
                "back": "Back",
                "goToLogin": "Proceed to Login Screen",
                "language": "Language",
                "myReservations": "My Reservations",
                "myAppointments": "My Appointments",
                "myCats": "My Cats",
                "myDogs": "My Dogs",
                "myVet": "My Vet",
                "myProfile": "My Profile",
                "emergencyContact": "Emergency Contact",
                "reservationOverview": "Reservation Overview",
                "serviceFee": "Service Fee",
                "configurationLabel": "Configuration",
                "newReservations": "New Reservations",
                "newAppointments": "New Appointments",
                "appointmentsConfigTabs": "Appointments configuration tabs",
                "services": "Services",
                "staffAndPlanning": "Staff & planning",
                "editStaffTitle": "Edit staff member",
                "newStaffTitle": "New staff member",
                "editServiceTitle": "Edit Service",
                "newServiceTitle": "New Service",
                "typeToSearchPersons": "Type to search persons",
                "canPerformServices": "Can perform services",
                "planning": "Planning",
                "startTime": "Start time",
                "endTime": "End time",
                "timeIntervalMin": "Time interval (min)",
                "allowedIntervalsHint": "Allowed: 15, 30, 60",
                "noActiveStaffWarning": "There are no active staff members. Customers cannot book appointments.",
                "selectAtLeastOneService": "Select at least one service",
                "selectAtLeastOneDay": "Select at least one day",
                "startBeforeEnd": "Start time must be before end time",
                "startEndRequired": "Start and end time are required",
                "intervalMustBe": "Interval must be 15, 30, or 60",
                "saveFailedTryAgain": "Save failed. Please try again.",
                "addBreak": "Break",
                "breakStart": "Break start",
                "breakEnd": "Break end",
                "makeReservation": "Make a Reservation",
                "makeAppointment": "Make an Appointment",
                "checkAvailability": "Check availability",
                "chooseService": "Choose a service",
                "loadingServices": "Loading services...",
                "servicesLoadFailed": "Failed to load services",
                "servicesTableAria": "Services table",
                "serviceSaved": "Service saved",
                "staffSaved": "Staff saved",
                "toggleActiveFailed": "Failed to update status",
                "retry": "Retry",
                "show": "Show",
                "hide": "Hide",
                "all": "All",
                "active": "Active",
                "inactive": "Inactive",
                "newService": "New service",
                "durationShort": "Duration",
                "durationMinutesLabel": "Duration (minutes)",
                "priceEuro": "Price (€)",
                "bufferBefore": "Buffer before",
                "bufferAfter": "Buffer after",
                "allAnimals": "All animals",
                "cat": "Cat",
                "dog": "Dog",
                "animalTypeLabel": {
                    "CAT": "cat(s)",
                    "DOG": "dog(s)"
                },
                "animalType": "Animal type",
                "chooseEmployee": "Choose an employee",
                "loadingEmployees": "Loading employees...",
                "start": "Start",
                "end": "End",
                "service": "Service",
                "employee": "Employee",
                "newReservationsError": "Could not fetch new reservations count",
                "fetchReservationsError": "Failed to retrieve my reservations",
                "for": "For",
                "stayType": "Stay Type",
                "status": "Status",
                "appointmentOverview": "Appointment Overview",
                "noAppointmentDetailsFound": "No appointment details found.",
                "termsAgreementLabel": "I agree to the terms and conditions",
                "confirmAppointment": "Confirm appointment",
                "notes": "Notes",
                "selectedAppointment": "Selected appointment",
                "animalNameLabel": "Name of the animal",
                "appointmentDate": "Appointment date",
                "timeslotSummary": "{{duration}} min • ends at {{endLabel}} • €{{price}}",
                "chooseTimeslot": "Choose a time slot",
                "bookingFailed": "Booking failed. Please try a different time or try again.",
                "date": "Date",
                "totalDuration": "Total duration",
                "minutes": "minutes",
                "preparationBufferMinutes": "Preparation: {{minutes}} min",
                "aftercareBufferMinutes": "Aftercare: {{minutes}} min",
                "noTimeslotsSuggestion": "No time slots available for this day. Try another date.",
                "loadingTimeslots": "Loading time slots...",
                "noteOptional": "Notes (optional)",
                "notePlaceholder": "Add notes (optional)",
                "addCatTitle": "Start here to add a new cat.",
                "catName": "Cat name",
                "selectForStay": "Select for stay",
                "addCatPlaceholder": "Add a cat",
                "continueToCalendar": "Continue to calendar",
                "fetchCatsForReservationError": "Could not fetch cats for reservation",
                "fetchMyCatsError": "Could not fetch my cats",
                "addCatError": "Could not add a new cat, please try again.",
                "selectCheckInDate": "Select the check-in date",
                "checkInDateLabel": "Check-in date",
                "dateUnavailableWarning": "Check-in is in the past and is no longer available!",
                "selectCheckOutDate": "Select the check-out date",
                "checkOutDateLabel": "Check-out date",
                "dateBeforeWarning": "Check-out is before check-in!",
                "selectStayTitle": "Select your stay",
                "selectStay": "Select stay",
                "selectStayDisplay": "{{price}} € / day for {{count}} {{animalTypeLabel}}",
                "selectStayLineDisplay": "{{count}} {{animalTypeLabel}} in the '{{name}}'",
                "noAvailableStays": "No stays available for the selected period.",
                "choose_stay_type": "Choose stay type",
                "updateDates": "Enter new check-in/check-out dates",
                "checkInHourTitle": "Specify the check-in hour",
                "noCheckInHoursAvailable": "No check-in hours are available at the moment. You can proceed with the reservation, and {{tenantName}} will contact you to arrange the check-in time.",
                "checkOutHourTitle": "Specify the check-out hour",
                "noCheckOutHoursAvailable": "No check-out hours are available at the moment. You can proceed with the reservation, and {{tenantName}} will contact you to arrange the check-out time.",
                "personalInformation": "Personal Information",
                "firstName": "First Name",
                "street": "Street",
                "houseNumber": "House Number",
                "apartment": "Apartment",
                "postalCode": "Postal Code",
                "municipality": "Municipality",
                "country": "Country",
                "gsm": "Mobile Number",
                "email": "Email",
                "nameRequired": "Name is a required field.",
                "firstNameRequired": "First Name is a required field.",
                "streetRequired": "Street is a required field.",
                "houseNumberRequired": "House Number is a required field.",
                "postalCodeRequired": "Postal Code is a required field.",
                "municipalityRequired": "Municipality is a required field.",
                "countryRequired": "Country is a required field.",
                "gsmRequired": "Mobile Number is a required field.",
                "emailRequired": "Email is a required field.",
                "invalidEmail": "Invalid email.",
                "fetchPersonInfoError": "Failed to retrieve person data.",
                "updatePersonInfoError": "Failed to update person data.",
                "veterinaryContactInfo": "Veterinary Contact Information",
                "practice": "Practice",
                "phoneNumber": "Phone Number",
                "location": "Location",
                "practiceRequired": "Practice is a required field.",
                "veterinarianRequired": "Veterinarian is a required field.",
                "phoneNumberRequired": "Phone Number is a required field.",
                "locationRequired": "Location is a required field.",
                "fetchVeterinaryError": "Failed to retrieve veterinarian information.",
                "updateVeterinaryError": "Failed to update veterinarian information.",
                "checkCatVaccinations": "How do I check my cat's vaccinations?",
                "checkDogVaccinations": "How do I check my dog's vaccinations?",
                "dog_vaccination_dhp": "DHP/DAP (distemper/adenovirus/parvo)",
                "dog_vaccination_lepto": "Leptospirosis (L4)",
                "dog_vaccination_kennel_cough": "Kennel cough (Bordetella ± parainfluenza)",
                "dog_vaccination_rabies_optional": "Rabies (optional)",
                "dog_medical_weightKg": "Weight (kg)",
                "dog_medical_sizeCategory": "Size category",
                "dog_size_xs": "XS",
                "dog_size_s": "S",
                "dog_size_m": "M",
                "dog_size_l": "L",
                "dog_size_xl": "XL",
                "dog_medical_hasMedication": "Takes medication",
                "dog_medical_medicationNotes": "Medication notes",
                "dog_medical_allergies": "Allergies",
                "dog_medical_femaleInHeat": "Female in heat",
                "dog_medical_lastHeatDate": "Last heat date",
                "dog_behavior_socialization": "Socialization",
                "dog_socialization_group_ok": "Group OK",
                "dog_socialization_small_group_only": "Small group only",
                "dog_socialization_solo_only": "Solo only",
                "dog_socialization_unknown": "Unknown",
                "dog_behavior_reactiveOnLeash": "Reactive on leash",
                "dog_behavior_resourceGuarding": "Resource guarding",
                "dog_behavior_separationAnxiety": "Separation anxiety",
                "dog_behavior_houseTrained": "House trained",
                "dog_behavior_biteHistory": "Bite history",
                "dog_behavior_biteHistoryNotes": "Bite history notes",
                "dog_behavior_muzzleRequired": "Muzzle required",
                "dog_behavior_okWithCats": "OK with cats",
                "emergencyContactTitle": "Emergency Contact if Unreachable",
                "fetchContactInfoError": "Failed to retrieve contact information.",
                "updateContactInfoError": "Failed to update contact information.",
                "reservationOverviewTitle": "Reservation Overview",
                "reservationNumber": "Reservation Number",
                "reservationPeriod": "Reservation for Period",
                "veterinaryPractice": "Veterinary Practice",
                "reservationFor": "Reservation for",
                "selectedStay": "Selected for stay",
                "XL": "Luxury or Maine Coon accommodation",
                "STANDARD": "Standard stay",
                "reservationPrice": "Reservation Price",
                "serviceFeeIncluded": "Service fee included",
                "advance": "Advance Payment",
                "confirmReservation": "Confirm Your Reservation",
                "fetchReservationError": "Failed to retrieve reservation overview.",
                "fetchPaymentLinkError": "Failed to retrieve payment link.",
                "paymentStatusFetchFailed": "Failed to retrieve payment status.",
                "reservationProcessingMessage": "We are processing your request.",
                "paymentOpenTitle": "Payment not completed?",
                "paymentFailedTitle": "Payment failed!",
                "paymentCanceledTitle": "Payment canceled?",
                "paymentRetryText": "Please try again",
                "redoPaymentButton": "Retry payment",
                "paymentSuccessTitle": "Payment completed successfully.",
                "paymentSuccessEmailNotice": "A confirmation email will be sent to",
                "reservationOverviewButton": "Reservation overview",
                "appointmentOverviewButton": "Appointment overview",
                "dayOverviewFetchFailed": "Failed to fetch day overview.",
                "monthOverviewFetchFailed": "Failed to fetch month overview.",
                "reservationManagementFetchFailed": "Failed to load reservations overview.",
                "fetchCatError": "Failed to fetch cat.",
                "fetchPersonError": "Failed to fetch person.",
                "updateMyCatsError": "Failed to update my cats.",
                "fetchStayInReservationFailed": "Failed to fetch stay in reservation.",
                "archiveAnimal": "Archive",
                "archiveCatConfirmTitle": "Archive cat?",
                "archiveCatConfirmMessage": "Are you sure you want to archive {{name}}? You can no longer select archived cats for new reservations.",
                "archiveCatSuccess": "Cat archived successfully.",
                "archiveCatFailed": "Failed to archive cat.",
                "itemsPerPage": "Items per page",
                "add_new_service_fee": "Add New Service Fee",
                "service_fees": "Service Fees",
                "start_date": "Start Date",
                "end_date": "End Date",
                "amount": "Amount",
                "edit": "Edit",
                "save_configuration": "Save Configuration",
                "schedule_period": "Schedule from {{startPeriod}} to {{endPeriod}}",
                "day_of_week": "Day of Week",
                "add_check_in_hours": "Add Check-in Hours",
                "check_in_hours": "Check-in Hours",
                "add_check_out_hours": "Add Check-out Hours",
                "check_out_hours": "Check-out Hours",
                "none": "None",
                "error_fetching_schedules": "Error fetching schedules",
                "new_reservations_error": "Unable to fetch new reservations",
                "download_contracts_error": "Failed to download contracts",
                "validate_reservation_error": "Failed to validate the new reservation",
                "cancel_reservation_error": "Failed to cancel the new reservation",
                "awaiting_advance": "Awaiting advance",
                "mark_advance_received": "Mark received",
                "mark_advance_received_error": "Failed to update advance status",
                "check_in": "Check-in",
                "check_out": "Check-out",
                "stay_types": "Stay Types",
                "service_name": "Service name",
                "price": "Price",
                "newest": "Newest",
                "cats": "Cat(s)",
                "update_reservation": "You are about to modify the reservation.",
                "countries": {
                    "Belgium": "Belgium",
                    "France": "France",
                    "Luxembourg": "Luxembourg",
                    "Netherlands": "Netherlands"
                },
                "vacations": "Vacation periods",
                "add_new_vacations": "Add new vacation",
                "addReservation": "Add new reservation",
                "error_fetching_vacations": "Failed to fetch vacation periods",
                "error_creating_vacations": "Failed to create a new vacation period",
                "error_deleting_vacations": "Failed to delete vacation period",
                "searchFailure": "Search failed",
                "createdReservationSuccessful": "Reservation successfully created",
                "createReservationFailed": "Failed to create reservation",
                "fetchAvailableStaysFailed": "Failed to fetch available stays",
                "checkAvailabilityFailed": "Failed to check reservation availability",
                "checkAvailabilityCheckInHoursFailed": "Failed to fetch available check-in hours",
                "checkAvailabilityCheckOutHoursFailed": "Failed to fetch available check-out hours",
                "ownerName": "Owner",
                "familie": "All cats",
                "selectCats": "Select cats",
                "hour": "Hour",
                "agreeTermsOfUse": "I agree to the service fee and the terms of use.",
                "termsOfUseRequired": "You must agree to the terms of use.",
                "stays": "Stays",
                "stay": "Stay",
                "checkInCheckOut": "Check-in and check-out",
                "emails": "Emails",
                "contracts": "Contracts",
                "description": "Description",
                "type": "Type",
                "stayNumber": "Stay number",
                "guestsPerStay": "Guests / stay",
                "staysConfig": "Stays configuration",
                "scheduleFromTo": "Schedule from %s to %s",
                "drawCheckInHours": "Draw check-in hours",
                "drawCheckOutHours": "Draw check-out hours",
                "time": "Time",
                "monday": "Monday",
                "tuesday": "Tuesday",
                "wednesday": "Wednesday",
                "thursday": "Thursday",
                "friday": "Friday",
                "saturday": "Saturday",
                "sunday": "Sunday",
                "emailTemplates": "Email templates",
                "newTemplate": "New template",
                "replyTo": "Reply-to",
                "subject": "Subject",
                "daysBeforeReservation": "Days before reservation",
                "preview": "Preview",
                "editTemplate": "Edit template",
                "emailType": "Email type",
                "bodyTextHtml": "Body",
                "RESERVATION_CONFIRMATION": "Reservation confirmation",
                "RESERVATION_REMINDER": "Reservation reminder",
                "APPOINTMENT_CONFIRMATION": "Appointment confirmation",
                "APPOINTMENT_REMINDER": "Appointment reminder",
                "BOOKING_OPEN_DATE": "Booking open date",
                "SERVICE_FEE": "Service fee",
                "suggestionsActive": "Suggestions active",
                "tipAutocomplete": "Tip: Type in UPPERCASE (e.g. CHE...) — ↑/↓ to select, Enter/Tab to complete. Available:",
                "livePreview": "Live preview",
                "newStay": "New stay",
                "editStay": "Edit stay",
                "noStaysMessage": "No stays yet. Click 'New stay' to get started.",
                "amountToCreate": "Amount to create",
                "from": "from",
                "to": "to",
                "currentOccupancy": "Current occupancy",
                "numberOfAppointmentsToday": "Number of appointments today",
                "ongoingReservations": "Ongoing reservations",
                "upcomingReservations": "Upcoming reservations",
                "noCurrentReservations": "No current reservations",
                "noUpcomingReservations": "No upcoming reservations",
                "specialAttention": "Special attention for",
                "noSpecialAttention": "No special attention",
                "yourLogoHere": "Your logo here",
                "checkInToday": "Check-in today",
                "noCheckInToday": "No check-in today",
                "checkOutToday": "Check-out today",
                "noCheckOutToday": "No check-out today",
                "animalsPage": {
                    "title": "Animals",
                    "searchLabel": "Animal name",
                    "name": "Name",
                    "birthDate": "Birthdate",
                    "owner": "Owner",
                    "emergencyContact": "Emergency contact",
                    "diet": "Diet",
                    "medicalHistory": "Medical history",
                    "yes": "Yes",
                    "no": "No",
                    "contactOtherAnimals": "Contact with other animals",
                    "address": "Address",
                    "reservations": "Reservations",
                    "actions": "Actions",
                    "viewDetail": "View details",
                    "noData": "No results to display."
                },
                "customersPage": {
                    "title": "Customers",
                    "searchLabel": "Customer name",
                    "name": "Name",
                    "email": "Email",
                    "phone": "Phone",
                    "emergencyContact": "Emergency contact",
                    "address": "Address",
                    "reservations": "Reservations",
                    "actions": "Actions",
                    "viewDetail": "View details",
                    "noData": "No results to display."
                },
                "january": "January",
                "february": "February",
                "march": "March",
                "april": "April",
                "may": "May",
                "june": "June",
                "july": "July",
                "august": "August",
                "september": "September",
                "october": "October",
                "november": "November",
                "december": "December",
                "noServicesFound": "No services found",
                "noStaffFound": "No staff members found",
                "configuratieparameters": "Configuration parameters",
                "appointments": "Appointments",
                "pageTitle": "Configuration Parameter",
                "startDate": "Start date",
                "endDate": "End date",
                "editConfiguratieParameter": "Edit configuration parameter",
                "loadFailed": "Loading failed",
                "saveFailed": "Saving failed",
                "attentionPoint": "Consideration",
                "unauthorizedBeheer": "Unauthorized for management",
                "validateReservationTitle":"Remove reservation from overview",
                "validateReservationMessage":"Are you sure you want to remove the reservation from the overview?",
                "cancelReservationTitle": "Cancel reservation",
                "cancelReservationMessage": "Are you sure you want to cancel the reservation?",
                // Status labels
                "statuses": {
                    "BOOKED": "Booked",
                    "BOOKED_AWAIT_ADVANCE": "Awaiting advance payment",
                    "CANCELLED": "Cancelled"
                },
                // App-specific grouped messages
                "attention": {
                    "save": {
                        "success": "Attention point saved",
                        "error": "Failed to save attention point"
                    }
                },
                "configuration": {
                    "save": {
                        "success": "Configuration saved",
                        "error": "Failed to save configuration"
                    }
                }
            }
        },
        fr: {
            translation: {
                "dashboard": "Tableau de bord",
                "animals": "Animaux",
                "customers": "Clients",
                "billing": "Facturation",
                "addAppointment": "Ajouter un rendez-vous",
                // DayView Component
                "cancelBooking": "Annuler la réservation",
                "confirmCancellation": "Êtes-vous sûr de vouloir annuler cette réservation?",
                "confirmEditReservation": "Vous êtes sur le point de modifier cette réservation.",
                "checkIn": "Enregistrement",
                "checkOut": "Départ",
                "owner": "Propriétaire",
                "veterinarian": "Vétérinaire",
                "actions": "Actions",
                "updateReservationHours": "Mettre à jour les heures de la réservation",
                "download_contracts": "Télécharger les contrats",
                "validate": "Retirer de l’aperçu",
                "yes": "Oui",
                "no": "Non",
                "save": "Enregistrer",
                "cancel": "Annuler",
                "confirm": "Confirmer",
                "removeThisTemplate": "Supprimer ce modèle",
                "templateRemoved": "Modèle supprimé",
                "contractTemplateSaved": "Modèle de contrat enregistré",
                "saveFirstForPdfPreview": "Enregistrez d'abord pour ouvrir un aperçu PDF.",
                "pdfPreviewFailed": "Échec de la génération de l'aperçu PDF",
                "imageUrlPrompt": "URL de l'image (https://...) :",
                "invalidImageUrl": "Utilisez une URL http(s) valide (ou data:image/...)",
                "pageBreak": "Saut de page",
                "insertPlaceholderAtCursor": "Insérer un espace réservé",
                "atCursor": "Au curseur :",
                "insertNewPageAtCursor": "Insérer une nouvelle page",
                "pdfPreview": "Aperçu PDF",
                "previewValues": "Valeurs d'aperçu",
                "editClientContract": "Modifier le contrat client",
                "removeFailed": "Échec de la suppression",
                "ignoreChanges": "Ignorer les modifications",
                "fillAllRequiredFields": "Remplissez tous les champs obligatoires",
                "areYouSureYouWantToRemoveThisStay": "Êtes-vous sûr de vouloir supprimer ce séjour ?",
                "editAppointment": "Modifier le rendez-vous",
                "editReservation": "Modifier la réservation",
                "updateReservationFailed": "Échec de la mise à jour de la réservation",
                "updatedReservationSuccessful": "Réservation mise à jour avec succes",
                "noActiveStaffWarning": "Il n'y a aucun membre du personnel actif. Les clients ne peuvent pas prendre de rendez-vous.",
                "animalNameLabel": "Nom de l’animal",
                "animalsPage": {
                    "title": "Animaux",
                    "searchLabel": "Nom de l'animal",
                    "name": "Nom",
                    "birthDate": "Date de naissance",
                    "owner": "Propriétaire",
                    "emergencyContact": "Contact d'urgence",
                    "diet": "Régime alimentaire",
                    "medicalHistory": "Historique médical",
                    "yes": "Oui",
                    "no": "Non",
                    "contactOtherAnimals": "Contact avec d'autres animaux",
                    "address": "Adresse",
                    "reservations": "Réservations",
                    "actions": "Actions",
                    "viewDetail": "Voir les détails",
                    "noData": "Aucun résultat à afficher."
                },
                "customersPage": {
                    "title": "Clients",
                    "searchLabel": "Nom du client",
                    "name": "Nom",
                    "email": "E-mail",
                    "phone": "Téléphone",
                    "emergencyContact": "Contact d'urgence",
                    "address": "Adresse",
                    "reservations": "Réservations",
                    "actions": "Actions",
                    "viewDetail": "Voir les détails",
                    "noData": "Aucun résultat à afficher."
                },
                // New Component
                "enterCatName": "Entrez le nom de votre chat",
                "catInfo": "Informations sur {{name}}",
                "name": "Nom",
                "birthDate": "Date de naissance",
                "breed": "Race",
                "sex": "Sexe",
                "male": "Mâle",
                "female": "Femelle",
                "unknown": "Inconnu",
                "color": "Couleur",
                "chipNumber": "Numéro de puce",
                "medicalInfo": "Informations médicales de {{name}}",
                "neutered": "Stérilisé",
                "dewormed": "Dépucé & Déparasité",
                "leukemia": "Leucémie féline (leucose)",
                "panleukopenia": "Panleucopénie (panleucopenie / typhus)",
                "coryza": "Coryza",
                "behavior": "Comportement de {{name}}",
                "basicInfo": "Informations de base",
                "healthSection": "Santé de {{name}}",
                "behaviorSection": "Comportement de {{name}}",
                "contactsSection": "Contacts",
                "reservationsSection": "Réservations",
                "appointmentsSection": "Rendez-vous",
                "pastAppointments": "Rendez-vous passés",
                "upcomingAppointments": "Rendez-vous à venir",
                "appointmentFor": "Rendez-vous pour",
                "associationAnimals": "Interaction avec d'autres animaux",
                "noUpcomingAppointments": "Aucun rendez-vous à venir",
                "noPastAppointments": "Aucun rendez-vous passé",
                "pastReservations": "Réservations passées",
                "noPastReservations": "Aucune réservation passée",
                "noReservationsFound": "Aucune réservation trouvée",
                "noAppointmentsFound": "Aucun rendez-vous trouvé",
                "homeBehavior": "Comportement à la maison",
                "diet": "Régime alimentaire",
                "medicalHistory": "Antécédents médicaux",
                "interactionWithAnimals": "Interaction avec d'autres animaux",
                "interactionWithAnimalsPlaceholder": "Interaction avec d'autres animaux",
                "allowContact": "Peut entrer en contact avec d'autres chats dans l'aire de jeu",
                "vaccinationRequiredTooltip": "Vaccination obligatoire pour un séjour chez {{tenantName}}",
                "vaccinationWarning": "Les vaccinations sont obligatoires pour séjourner chez {{tenantName}} et seront vérifiées lors de l'enregistrement. Si les vaccinations sont incomplètes, l'entrée de votre chat sera refusée.",
                "previous": "Précédent",
                "next": "Suivant",
                "update": "Mettre à jour",
                "fillData": "Remplissez les informations pour {{name}}",
                "submit": "Soumettre",
                "loginPrompt": "Connectez-vous pour faire une réservation.",
                "backToTenant": "Retour à {{tenantName}}",
                "back": "Retour",
                "goToLogin": "Aller à l'écran de connexion",
                "language": "Langue",
                "myReservations": "Mes Réservations",
                "myAppointments": "Mes Rendez-vous",
                "myCats": "Mes Chats",
                "myDogs": "Mes Chiens",
                "myVet": "Mon Vétérinaire",
                "myProfile": "Mon Profil",
                "emergencyContact": "Contact d'urgence",
                "reservationOverview": "Vue des réservations",
                "serviceFee": "Frais de service",
                "configurationLabel": "Configuration",
                "newReservations": "Nouvelles réservations",
                "newAppointments": "Nouveaux rendez-vous",
                "appointmentsConfigTabs": "Onglets de configuration des rendez-vous",
                "services": "Services",
                "staffAndPlanning": "Personnel et planification",
                "editStaffTitle": "Modifier le membre du personnel",
                "newStaffTitle": "Nouveau membre du personnel",
                "editServiceTitle": "Modifier le service",
                "newServiceTitle": "Nouveau service",
                "typeToSearchPersons": "Tapez pour rechercher des personnes",
                "canPerformServices": "Peut effectuer les services",
                "planning": "Planification",
                "startTime": "Heure de début",
                "endTime": "Heure de fin",
                "timeIntervalMin": "Intervalle (min)",
                "allowedIntervalsHint": "Autorisés : 15, 30, 60",
                "selectAtLeastOneService": "Sélectionnez au moins un service",
                "selectAtLeastOneDay": "Sélectionnez au moins un jour",
                "startBeforeEnd": "L'heure de début doit être avant l'heure de fin",
                "startEndRequired": "Heures de début et de fin requises",
                "intervalMustBe": "L'intervalle doit être 15, 30 ou 60",
                "saveFailedTryAgain": "Échec de l'enregistrement. Veuillez réessayer.",
                "addBreak": "Une pause",
                "breakStart": "Début de la pause",
                "breakEnd": "Fin de la pause",
                "newReservationsError": "Impossible de récupérer le nombre de nouvelles réservations",
                "fetchReservationsError": "Échec de la récupération de mes réservations",
                "start": "Début",
                "end": "Fin",
                "service": "Service",
                "employee": "Employé",
                "for": "Pour",
                "stayType": "Type de séjour",
                "status": "Statut",
                "appointmentOverview": "Aperçu du rendez-vous",
                "noAppointmentDetailsFound": "Aucun détail de rendez-vous trouvé.",
                "termsAgreementLabel": "J'accepte les termes et conditions",
                "confirmAppointment": "Confirmer le rendez-vous",
                "notes": "Notes",
                "selectedAppointment": "Rendez-vous sélectionné",
                "appointmentDate": "Date du rendez-vous",
                "timeslotSummary": "{{duration}} min • se termine à {{endLabel}} • €{{price}}",
                "chooseTimeslot": "Choisissez un créneau",
                "bookingFailed": "La réservation a échoué. Veuillez essayer un autre horaire ou réessayer.",
                "date": "Date",
                "totalDuration": "Durée totale",
                "minutes": "minutes",
                "preparationBufferMinutes": "Préparation : {{minutes}} min",
                "aftercareBufferMinutes": "Après-soins : {{minutes}} min",
                "noTimeslotsSuggestion": "Aucun créneau disponible pour ce jour. Essayez une autre date.",
                "loadingTimeslots": "Chargement des créneaux...",
                "noteOptional": "Notes (optionnel)",
                "notePlaceholder": "Ajouter des notes (optionnel)",
                "makeReservation": "Faire une réservation",
                "makeAppointment": "Prendre un rendez-vous",
                "checkAvailability": "Vérifier la disponibilité",
                "chooseService": "Choisissez un service",
                "servicesLoadFailed": "Échec du chargement des services",
                "servicesTableAria": "Table des services",
                "serviceSaved": "Service enregistré",
                "staffSaved": "Personnel enregistré",
                "toggleActiveFailed": "Échec de la mise à jour du statut",
                "retry": "Réessayer",
                "show": "Afficher",
                "hide": "Masquer",
                "all": "Tous",
                "active": "Actif",
                "inactive": "Inactif",
                "newService": "Nouveau service",
                "durationShort": "Durée",
                "durationMinutesLabel": "Durée (minutes)",
                "priceEuro": "Prix (€)",
                "bufferBefore": "Préparation",
                "bufferAfter": "Après-soins",
                "animalType": "Type d'animal",
                "noServicesFound": "Aucun service trouvé",
                "toggleActiveFor": "Basculer l'état pour {{name}} (mettre {{state}})",
                "on": "activer",
                "off": "désactiver",
                "allAnimals": "Tous les animaux",
                "cat": "Chat",
                "dog": "Chien",
                "animalTypeLabel": {
                    "CAT": "chat(s)",
                    "DOG": "chien(s)"
                },
                "service_name": "Nom du service",
                "chooseEmployee": "Choisissez un employé",
                "loadingServices": "Chargement des services...",
                "loadingEmployees": "Chargement des employés...",
                "addCatTitle": "Commencez ici pour ajouter un nouveau chat.",
                "catName": "Nom du chat",
                "selectForStay": "Sélectionner pour le séjour",
                "addCatPlaceholder": "Ajouter un chat",
                "continueToCalendar": "Continuer vers le calendrier",
                "fetchCatsForReservationError": "Impossible de récupérer les chats pour la réservation",
                "fetchMyCatsError": "Impossible de récupérer mes chats",
                "addCatError": "Impossible d'ajouter un nouveau chat, veuillez réessayer.",
                "selectCheckInDate": "Sélectionnez la date d'arrivée",
                "checkInDateLabel": "Date d'arrivée",
                "dateUnavailableWarning": "L'arrivée est dans le passé et n'est plus disponible!",
                "selectCheckOutDate": "Sélectionnez la date de départ",
                "checkOutDateLabel": "Date de départ",
                "dateBeforeWarning": "Le départ est avant l'arrivée!",
                "selectStayTitle": "Sélectionnez votre séjour",
                "selectStay": "Sélectionnez le séjour",
                "selectStayDisplay": "{{price}} € / jour pour {{count}} {{animalTypeLabel}}",
                "selectStayLineDisplay": "{{count}} {{animalTypeLabel}} dans le '{{name}}'",
                "noAvailableStays": "Aucun séjour disponible pour la période sélectionnée.",
                "choose_stay_type": "Choisissez le type de séjour",
                "updateDates": "Entrez de nouvelles dates d'arrivée/départ",
                "checkInHourTitle": "Indiquez l'heure d'arrivée",
                "noCheckInHoursAvailable": "Il n'y a pas d'heures d'arrivée disponibles pour le moment. Vous pouvez continuer la réservation, et {{tenantName}} vous contactera pour fixer l'heure d'arrivée.",
                "checkOutHourTitle": "Indiquez l'heure de départ",
                "noCheckOutHoursAvailable": "Il n'y a pas d'heures de départ disponibles pour le moment. Vous pouvez continuer la réservation, et {{tenantName}} vous contactera pour fixer l'heure de départ.",
                "personalInformation": "Informations personnelles",
                "firstName": "Prénom",
                "street": "Rue",
                "houseNumber": "Numéro",
                "apartment": "Appartement",
                "postalCode": "Code postal",
                "municipality": "Commune",
                "country": "Pays",
                "gsm": "Numéro de mobile",
                "email": "E-mail",
                "nameRequired": "Le nom est obligatoire.",
                "firstNameRequired": "Le prénom est obligatoire.",
                "streetRequired": "La rue est obligatoire.",
                "houseNumberRequired": "Le numéro est obligatoire.",
                "postalCodeRequired": "Le code postal est obligatoire.",
                "municipalityRequired": "La commune est obligatoire.",
                "countryRequired": "Le pays est obligatoire.",
                "gsmRequired": "Le numéro de mobile est obligatoire.",
                "emailRequired": "L'e-mail est obligatoire.",
                "invalidEmail": "E-mail non valide.",
                "fetchPersonInfoError": "Échec de la récupération des données de la personne.",
                "updatePersonInfoError": "Échec de la mise à jour des données de la personne.",
                "veterinaryContactInfo": "Informations de contact vétérinaire",
                "practice": "Cabinet",
                "phoneNumber": "Numéro de téléphone",
                "location": "Localisation",
                "practiceRequired": "Le cabinet est obligatoire.",
                "veterinarianRequired": "Le vétérinaire est obligatoire.",
                "phoneNumberRequired": "Le numéro de téléphone est obligatoire.",
                "locationRequired": "La localisation est obligatoire.",
                "fetchVeterinaryError": "Échec de la récupération des informations du vétérinaire.",
                "updateVeterinaryError": "Échec de la mise à jour des informations du vétérinaire.",
                "checkCatVaccinations": "Comment vérifier les vaccins de mon chat ?",
                "checkDogVaccinations": "Comment vérifier les vaccins de mon chien ?",
                "dog_vaccination_dhp": "DHP/DAP (maladie de Carré/Adénovirus/Parvovirus)",
                "dog_vaccination_lepto": "Leptospirose (L4)",
                "dog_vaccination_kennel_cough": "Toux de chenil (Bordetella ± parainfluenza)",
                "dog_vaccination_rabies_optional": "Rage (optionnel)",
                "dog_medical_weightKg": "Poids (kg)",
                "dog_medical_sizeCategory": "Taille",
                "dog_size_xs": "XS",
                "dog_size_s": "S",
                "dog_size_m": "M",
                "dog_size_l": "L",
                "dog_size_xl": "XL",
                "dog_medical_hasMedication": "Prend des médicaments",
                "dog_medical_medicationNotes": "Notes médicaments",
                "dog_medical_allergies": "Allergies",
                "dog_medical_femaleInHeat": "Femelle en chaleur",
                "dog_medical_lastHeatDate": "Dernières chaleurs",
                "dog_behavior_socialization": "Socialisation",
                "dog_socialization_group_ok": "Groupe OK",
                "dog_socialization_small_group_only": "Petit groupe uniquement",
                "dog_socialization_solo_only": "Solo uniquement",
                "dog_socialization_unknown": "Inconnu",
                "dog_behavior_reactiveOnLeash": "Réactif en laisse",
                "dog_behavior_resourceGuarding": "Protection des ressources",
                "dog_behavior_separationAnxiety": "Anxiété de séparation",
                "dog_behavior_houseTrained": "Propreté",
                "dog_behavior_biteHistory": "Antécédents de morsure",
                "dog_behavior_biteHistoryNotes": "Notes morsures",
                "dog_behavior_muzzleRequired": "Muselière requise",
                "dog_behavior_okWithCats": "OK avec les chats",
                "emergencyContactTitle": "Contact d'urgence si injoignable",
                "fetchContactInfoError": "Échec de la récupération des informations de contact.",
                "updateContactInfoError": "Échec de la mise à jour des informations de contact.",
                "reservationOverviewTitle": "Aperçu de la réservation",
                "reservationNumber": "Numéro de réservation",
                "reservationPeriod": "Période de réservation",
                "veterinaryPractice": "Cabinet vétérinaire",
                "reservationFor": "Réservation pour",
                "selectedStay": "Sélectionné pour le séjour",
                "XL": "L’hébergement de luxe ou pour Maine Coon",
                "STANDARD": "L’hébergement de luxe ou pour Maine Coon",
                "reservationPrice": "Prix de la réservation",
                "serviceFeeIncluded": "Frais de service inclus",
                "advance": "Acompte",
                "confirmReservation": "Confirmez votre réservation",
                "fetchReservationError": "Échec de la récupération de l'aperçu de la réservation.",
                "fetchPaymentLinkError": "Échec de la récupération du lien de paiement.",
                "paymentStatusFetchFailed": "Échec de la récupération du statut de paiement.",
                "reservationProcessingMessage": "Nous traitons votre demande.",
                "paymentOpenTitle": "Paiement non effectué ?",
                "paymentFailedTitle": "Paiement échoué !",
                "paymentCanceledTitle": "Paiement annulé ?",
                "paymentRetryText": "Veuillez réessayer",
                "redoPaymentButton": "Réessayer le paiement",
                "paymentSuccessTitle": "Paiement effectué avec succès.",
                "paymentSuccessEmailNotice": "Un e-mail de confirmation sera envoyé à",
                "reservationOverviewButton": "Aperçu des réservations",
                "appointmentOverviewButton": "Aperçu des rendez-vous",
                "dayOverviewFetchFailed": "Échec du chargement de l'aperçu du jour.",
                "monthOverviewFetchFailed": "Échec du chargement de l'aperçu du mois.",
                "reservationManagementFetchFailed": "Échec du chargement de l'aperçu des réservations.",
                "fetchCatError": "Échec de la récupération du chat.",
                "fetchPersonError": "Échec de la récupération de la personne.",
                "updateMyCatsError": "Échec de la mise à jour de mes chats.",
                "fetchStayInReservationFailed": "Échec de la récupération du séjour dans la réservation.",
                "archiveAnimal": "Archiver",
                "archiveCatConfirmTitle": "Archiver le chat ?",
                "archiveCatConfirmMessage": "Êtes-vous sûr de vouloir archiver {{name}} ? Vous ne pourrez plus sélectionner les chats archivés pour de nouvelles réservations.",
                "archiveCatSuccess": "Chat archivé avec succès.",
                "archiveCatFailed": "Échec de l'archivage du chat.",
                "itemsPerPage": "Lignes par page",
                "add_new_service_fee": "Ajouter une Nouvelle Frais de Service",
                "service_fees": "Frais de Service",
                "start_date": "Date de Début",
                "end_date": "Date de Fin",
                "amount": "Montant",
                "edit": "Modifier",
                "save_configuration": "Enregistrer la Configuration",
                "schedule_period": "Horaire du {{startPeriod}} au {{endPeriod}}",
                "day_of_week": "Jour de la Semaine",
                "add_check_in_hours": "Ajouter les Heures d'Arrivée",
                "check_in_hours": "Heures d'Arrivée",
                "add_check_out_hours": "Ajouter les Heures de Départ",
                "check_out_hours": "Heures de Départ",
                "none": "Aucun",
                "error_fetching_schedules": "Erreur lors de la récupération des horaires",
                "new_reservations_error": "Impossible de récupérer les nouvelles réservations",
                "download_contracts_error": "Échec du téléchargement des contrats",
                "validate_reservation_error": "Échec de la validation de la nouvelle réservation",
                "cancel_reservation_error": "Échec de la annuler de la nouvelle réservation",
                "awaiting_advance": "En attente de l'acompte",
                "mark_advance_received": "Marquer reçu",
                "mark_advance_received_error": "Échec de la mise à jour du statut de l'acompte",
                "check_in": "Arrivée",
                "check_out": "Départ",
                "stay_types": "Types de séjour",
                "price": "Prix",
                "newest": "Le plus récent",
                "cats": "Chat(s)",
                "update_reservation": "Vous êtes sur le point de modifier la réservation.",
                "countries": {
                    "Belgium": "Belgique",
                    "France": "France",
                    "Luxembourg": "Luxembourg",
                    "Netherlands": "Pays-Bas"
                },
                "vacations": "Périodes de vacances",
                "add_new_vacations": "Ajouter une nouvelle période de vacances",
                "addReservation": "Ajouter réservation",
                "error_fetching_vacations": "Échec de la récupération des périodes de vacances",
                "error_creating_vacations": "Échec de la création d'une nouvelle période de vacances",
                "error_deleting_vacations": "Échec de la suppression de la période de vacances",
                "searchFailure": "La recherche a échoué",
                "createdReservationSuccessful": "Réservation créée avec succès",
                "createReservationFailed": "Échec de la création de la réservation",
                "fetchAvailableStaysFailed": "Échec de la récupération des séjours disponibles",
                "checkAvailabilityFailed": "Échec de la vérification de la disponibilité de la réservation",
                "checkAvailabilityCheckInHoursFailed": "Échec de la récupération des heures d'arrivée disponibles",
                "checkAvailabilityCheckOutHoursFailed": "Échec de la récupération des heures de départ disponibles",
                "ownerName": "Propriétaire",
                "familie": "Tous les chats",
                "selectCats": "Sélectionnez des chats",
                "hour": "Heure",
                "agreeTermsOfUse": "J'accepte les frais de service et les conditions d'utilisation.",
                "termsOfUseRequired": "Vous devez accepter les conditions d'utilisation.",
                "stays": "Séjours",
                "stay": "Séjour",
                "checkInCheckOut": "Arrivée et départ",
                "emails": "E-mails",
                "contracts": "Contrats",
                "description": "Description",
                "type": "Type",
                "stayNumber": "Numéro de séjour",
                "guestsPerStay": "Invités / séjour",
                "staysConfig": "Configuration des séjours",
                "scheduleFromTo": "Horaire de %s à %s",
                "drawCheckInHours": "Dessiner les heures d'arrivée",
                "drawCheckOutHours": "Dessiner les heures de départ",
                "time": "Heure",
                "monday": "Lundi",
                "tuesday": "Mardi",
                "wednesday": "Mercredi",
                "thursday": "Jeudi",
                "friday": "Vendredi",
                "saturday": "Samedi",
                "sunday": "Dimanche",
                "emailTemplates": "Modèles d'e-mails",
                "newTemplate": "Nouveau modèle",
                "replyTo": "Répondre à",
                "subject": "Objet",
                "daysBeforeReservation": "Jours avant la réservation",
                "preview": "Aperçu",
                "editTemplate": "Modifier le modèle",
                "emailType": "Type d'e-mail",
                "bodyTextHtml": "Corps",
                "RESERVATION_CONFIRMATION": "Confirmation de réservation",
                "RESERVATION_REMINDER": "Rappel de réservation",
                "APPOINTMENT_CONFIRMATION": "Confirmation de rendez-vous",
                "APPOINTMENT_REMINDER": "Rappel de rendez-vous",
                "BOOKING_OPEN_DATE": "Date d’ouverture des réservations",
                "SERVICE_FEE": "Frais de service",
                "suggestionsActive": "Suggestions actives",
                "tipAutocomplete": "Astuce : Tapez en MAJUSCULES (ex. CHE...) — ↑/↓ pour sélectionner, Entrée/Tab pour compléter. Disponible :",
                "livePreview": "Aperçu en direct",
                "newStay": "Nouveau séjour",
                "editStay": "Modifier le séjour",
                "noStaysMessage": "Aucun séjour pour le moment. Cliquez sur 'Nouveau séjour' pour commencer.",
                "amountToCreate": "Nombre à créer",
                "from": "de",
                "to": "à",
                "currentOccupancy": "Occupation actuelle",
                "numberOfAppointmentsToday": "Nombre de rendez-vous aujourd'hui",
                "ongoingReservations": "Réservations en cours",
                "upcomingReservations": "Réservations à venir",
                "noCurrentReservations": "Aucune réservation en cours",
                "noUpcomingReservations": "Aucune réservation à venir",
                "specialAttention": "Attention spéciale pour",
                "noSpecialAttention": "Aucune attention spéciale",
                "yourLogoHere": "Votre logo ici",
                "checkInToday": "Arrivée aujourd'hui",
                "noCheckInToday": "Aucune arrivée aujourd'hui",
                "checkOutToday": "Départ aujourd'hui",
                "noCheckOutToday": "Aucun départ aujourd'hui",
                "noStaffFound": "Aucun membre du personnel trouvé",
                "configuratieparameters": "Paramètres de configuration",
                "appointments": "Rendez-vous",
                "january": "janvier",
                "february": "février",
                "march": "mars",
                "april": "avril",
                "may": "mai",
                "june": "juin",
                "july": "juillet",
                "august": "août",
                "september": "septembre",
                "october": "octobre",
                "november": "novembre",
                "december": "décembre",
                "pageTitle": "Paramètre de configuration",
                "startDate": "Date de début",
                "endDate": "Date de fin",
                "editConfiguratieParameter": "Modifier le paramètre de configuration",
                "loadFailed": "Échec du chargement",
                "saveFailed": "Échec de l’enregistrement",
                "attentionPoint": "Point d’attention",
                "unauthorizedBeheer": "Non autorisé pour la gestion",
                "validateReservationTitle":"Supprimer la réservation de l’aperçu",
                "validateReservationMessage":"Êtes-vous sûr de vouloir supprimer la réservation de l’aperçu?",
                "cancelReservationTitle": "Annuler la réservation",
                "cancelReservationMessage": "Êtes-vous sûr de vouloir annuler la réservation?",
                // Libellés de statut
                "statuses": {
                    "BOOKED": "Réservé",
                    "BOOKED_AWAIT_ADVANCE": "En attente d'acompte",
                    "CANCELLED": "Annulé"
                },
                // Messages groupés spécifiques à l'application
                "attention": {
                    "save": {
                        "success": "Point d’attention enregistré",
                        "error": "Échec de l’enregistrement du point d’attention"
                    }
                },
                "configuration": {
                    "save": {
                        "success": "Configuration enregistrée",
                        "error": "Échec de l’enregistrement de la configuration"
                    }
                }
            }
        },
        nl: {
            translation: {
                "dashboard": "Dashboard",
                "animals": "Dieren",
                "customers": "Klanten",
                "billing": "Facturatie",
                "addAppointment": "Afspraak toevoegen",
                // DayView Component
                "appointmentsConfigTabs": "Tabbladen voor afsprakenconfiguratie",
                "services": "Diensten",
                "staffAndPlanning": "Personeel en planning",
                "editStaffTitle": "Medewerker bewerken",
                "newStaffTitle": "Nieuwe medewerker",
                "editServiceTitle": "Dienst bewerken",
                "newServiceTitle": "Nieuwe dienst",
                "typeToSearchPersons": "Typ om personen te zoeken",
                "canPerformServices": "Kan diensten uitvoeren",
                "planning": "Planning",
                "startTime": "Starttijd",
                "endTime": "Eindtijd",
                "timeIntervalMin": "Tijdsinterval (min)",
                "allowedIntervalsHint": "Toegestaan: 15, 30, 60",
                "noActiveStaffWarning": "Er zijn geen actieve medewerkers. Klanten kunnen geen afspraken boeken.",
                "selectAtLeastOneService": "Selecteer minstens één dienst",
                "selectAtLeastOneDay": "Selecteer minstens één dag",
                "startBeforeEnd": "Starttijd moet vóór eindtijd liggen",
                "startEndRequired": "Start- en eindtijd zijn verplicht",
                "intervalMustBe": "Interval moet 15, 30 of 60 zijn",
                "saveFailedTryAgain": "Opslaan mislukt. Probeer opnieuw.",
                "addBreak": "Pauze",
                "breakStart": "Start pauze",
                "breakEnd": "Einde pauze",
                "cancelBooking": "Boeking annuleren",
                "confirmCancellation": "Weet u zeker dat u deze booking wil annuleren?",
                "confirmEditReservation": "U staat op het punt reservatie aan te passen.",
                "checkIn": "Check-in",
                "checkOut": "Check-out",
                "owner": "Eigenaar",
                "veterinarian": "Dierenarts",
                "actions": "Acties",
                "updateReservationHours": "Reservatie-uren aanpassen",
                "download_contracts": "Contracten downloaden",
                "validate": "Reservatie uit overzicht halen",
                "yes": "Ja",
                "no": "Nee",
                "save": "Opslaan",
                "cancel": "Annuleren",
                "confirm": "Bevestigen",
                "removeThisTemplate": "Dit sjabloon verwijderen",
                "templateRemoved": "Sjabloon verwijderd",
                "contractTemplateSaved": "Contract sjabloon opgeslagen",
                "saveFirstForPdfPreview": "Sla eerst op om een PDF preview te openen.",
                "pdfPreviewFailed": "PDF preview genereren mislukt",
                "imageUrlPrompt": "Afbeelding URL (https://...):",
                "invalidImageUrl": "Gebruik een geldige http(s) URL (of data:image/...)",
                "pageBreak": "Pagina-einde",
                "insertPlaceholderAtCursor": "Placeholder invoegen",
                "atCursor": "Aan cursor:",
                "insertNewPageAtCursor": "Nieuwe pagina invoegen",
                "pdfPreview": "PDF voorbeeld",
                "previewValues": "Voorbeeldwaarden",
                "editClientContract": "Klantcontract bewerken",
                "removeFailed": "Verwijderen mislukt",
                "ignoreChanges": "Wijzigingen negeren",
                "fillAllRequiredFields": "Vul alle verplichte velden in",
                "areYouSureYouWantToRemoveThisStay": "Weet je zeker dat je dit verblijf wil verwijderen?",
                "editAppointment": "Afspraak aanpassen",
                "editReservation": "Reservatie aanpassen",
                "updateReservationFailed": "Aanpassen van reservatie mislukt",
                "updatedReservationSuccessful": "Reservatie aanpassen succesvol",
                "photoSaved": "Foto opgeslagen",
                "uploadFailed": "Uploaden mislukt",
                "photoOf": "Foto van {{name}}",
                "chooseFile": "Bestand kiezen",
                "chooseAnotherFile": "Ander bestand kiezen",
                "clickToUpload": "Klik om te uploaden",
                "uploading": "Uploaden...",
                "invalidFileType": "Ongeldig bestandstype. Kies JPG, PNG of WebP.",
                "fileTooLarge": "Bestand is te groot. Maximum is 5 MB.",
                "uploadPhoto": "Foto uploaden",
                "changePhoto": "Foto aanpassen",
                "animalNameLabel": "Naam van het dier",
                "customersPage": {
                    "title": "Klanten",
                    "searchLabel": "Naam van de klant",
                    "name": "Naam",
                    "email": "E-mail",
                    "phone": "Telefoon",
                    "emergencyContact": "Noodcontact",
                    "address": "Adres",
                    "reservations": "Reservaties",
                    "actions": "Actions",
                    "viewDetail": "Bekijk details",
                    "noData": "Geen resultaten om te tonen."
                },
                "animalsPage": {
                    "title": "Dieren",
                    "searchLabel": "Naam van het dier",
                    "name": "Naam",
                    "birthDate": "Geboortedatum",
                    "owner": "Eigenaar",
                    "emergencyContact": "Noodcontact",
                    "diet": "Dieet",
                    "medicalHistorie": "Medische geschiedenis",
                    "yes": "Ja",
                    "no": "Nee",
                    "contactOtherAnimals": "Contact andere dieren",
                    "address": "Adres",
                    "reservations": "Reservaties",
                    "actions": "Actions",
                    "viewDetail": "Bekijk details",
                    "noData": "Geen resultaten om te tonen."
                },
                "servicesLoadFailed": "Laden van diensten mislukt",
                "servicesTableAria": "Tabel met diensten",
                "serviceSaved": "Dienst opgeslagen",
                "staffSaved": "Medewerker opgeslagen",
                "toggleActiveFailed": "Bijwerken van status mislukt",
                "retry": "Opnieuw",
                "show": "Toon",
                "hide": "Verbergen",
                "all": "Alle",
                "active": "Actief",
                "inactive": "Inactief",
                "newService": "Nieuwe dienst",
                "durationShort": "Duur",
                "durationMinutesLabel": "Duur (minuten)",
                "priceEuro": "Prijs (€)",
                "bufferBefore": "Buffer voor",
                "bufferAfter": "Buffer na",
                "allAnimals": "Alle dieren",
                "cat": "Kat",
                "dog": "Hond",
                "animalTypeLabel": {
                    "CAT": "kat(ten)",
                    "DOG": "hond(en)"
                },
                "animalType": "Diersoort",

                // New Component
                "enterCatName": "Geef de naam in van je kat",
                "catInfo": "Gegevens over {{name}}",
                "name": "Naam",
                "birthDate": "Geboortedatum",
                "breed": "Ras",
                "sex": "Geslacht",
                "male": "Mannelijk",
                "female": "Vrouwelijk",
                "unknown": "Onbekend",
                "color": "Kleur",
                "chipNumber": "Chipnummer",
                "medicalInfo": "Medische informatie van {{name}}",
                "neutered": "Castratie/sterilisatie",
                "dewormed": "Ontvlooit & ontwormt",
                "leukemia": "Kattenleukemie (leucose)",
                "panleukopenia": "Kattenziekte (panleucopenie / typhus)",
                "coryza": "Niesziekte (rhinotracheïtis / coryza)",
                "behavior": "Gedrag van {{name}}",
                "basicInfo": "Basisgegevens",
                "healthSection": "Gezondheid",
                "behaviorSection": "Gedrag",
                "contactsSection": "Contacten",
                "reservationsSection": "Reservaties",
                "appointmentsSection": "Afspraken",
                "pastAppointments": "Afgelopen afspraken",
                "upcomingAppointments": "Aankomende afspraken",
                "appointmentFor": "Afspraak voor",
                "associationAnimals": "Omgang met andere dieren",
                "noUpcomingAppointments": "Geen aankomende afspraken",
                "noPastAppointments": "Geen afgelopen afspraken",
                "pastReservations": "Afgelopen reservaties",
                "noPastReservations": "Geen afgelopen reservaties",
                "noReservationsFound": "Geen reservaties gevonden",
                "noAppointmentsFound": "Geen afspraken gevonden",
                "homeBehavior": "Gedrag thuis",
                "diet": "Dieet",
                "medicalHistory": "Medische geschiedenis",
                "interactionWithAnimals": "Omgang met andere dieren",
                "allowContact": "Mag in contact komen met andere katten in de speelruimte",
                "vaccinationRequiredTooltip": "Verplichte vaccinatie voor een verblijf bij {{tenantName}}",
                "vaccinationWarning": "Vaccinaties zijn verplicht voor een verblijf bij {{tenantName}}, dit wordt steeds gecontroleerd bij check-in. Wanneer vaccinaties niet volledig zijn, zal uw kat geweigerd worden!",
                "previous": "Vorige",
                "next": "Volgende",
                "update": "Update",
                "fillData": "Vul de gegevens aan van {{name}}",
                "submit": "Verzenden",
                "loginPrompt": "Log in om een reservatie te maken.",
                "backToTenant": "Terug naar {{tenantName}}",
                "back": "Terug",
                "goToLogin": "Verder gaan naar inlogscherm",
                "myReservations": "Mijn Reservaties",
                "myAppointments": "Mijn Afspraken",
                "language": "Taal",
                "chooseService": "Kies een dienst",
                "chooseEmployee": "Kies een medewerker",
                "myCats": "Mijn Katten",
                "myDogs": "Mijn Honden",
                "myVet": "Mijn Dierenarts",
                "myProfile": "Mijn Profiel",
                "emergencyContact": "Noodcontact",
                "reservationOverview": "Reservatie overzicht",
                "serviceFee": "Service Fee",
                "configurationLabel": "Configuratie",
                "newReservations": "Nieuwe reservaties",
                "newAppointments": "Nieuwe afspraken",
                "newReservationsError": "Aantal nieuwe reservaties kon niet opgehaald worden",
                "fetchReservationsError": "Mijn reservaties ophalen mislukt",
                "start": "Start",
                "end": "Einde",
                "service": "Dienst",
                "employee": "Medewerker",
                "for": "Voor",
                "stayType": "Verblijf type",
                "status": "Status",
                "appointmentOverview": "Afspraakoverzicht",
                "noAppointmentDetailsFound": "Geen afspraakdetails gevonden.",
                "termsAgreementLabel": "Ik ga akkoord met de voorwaarden",
                "confirmAppointment": "Afspraak bevestigen",
                "notes": "Notitie",
                "selectedAppointment": "Geselecteerde afspraak",
                "appointmentDate": "Afspraakdatum",
                "timeslotSummary": "{{duration}} min • eindigt om {{endLabel}} • €{{price}}",
                "chooseTimeslot": "Kies een tijdslot",
                "bookingFailed": "Boeking mislukt. Probeer een ander tijdstip of probeer opnieuw.",
                "date": "Datum",
                "totalDuration": "Totale duur",
                "minutes": "minuten",
                "preparationBufferMinutes": "Voorbereiding: {{minutes}} min",
                "aftercareBufferMinutes": "Nazorg: {{minutes}} min",
                "noTimeslotsSuggestion": "Geen tijdsloten beschikbaar voor deze dag. Probeer een andere datum.",
                "loadingTimeslots": "Tijdsloten laden...",
                "noteOptional": "Notitie (optioneel)",
                "notePlaceholder": "Voeg een notitie toe (optioneel)",
                "makeReservation": "Maak een reservatie",
                "makeAppointment": "Maak een afspraak",
                "checkAvailability": "Beschikbaarheid nakijken",
                "loadingServices": "Diensten laden...",
                "loadingEmployees": "Medewerkers laden...",
                "addCatTitle": "Start hier om een nieuwe kat toe te voegen.",
                "catName": "Naam van de kat",
                "selectForStay": "Selecteer voor verblijf",
                "addCatPlaceholder": "Voeg een kat toe",
                "continueToCalendar": "Doorgaan naar kalender",
                "fetchCatsForReservationError": "Katten voor reservatie konden niet opgehaald worden",
                "fetchMyCatsError": "Mijn katten konden niet worden opgehaald",
                "addCatError": "Nieuwe kat kan niet toegevoegd worden, probeer opnieuw.",
                "selectCheckInDate": "Selecteer de check-in datum",
                "checkInDateLabel": "Check-in datum",
                "dateUnavailableWarning": "Check-in ligt in het verleden en is niet meer beschikbaar!",
                "selectCheckOutDate": "Selecteer de check-out datum",
                "checkOutDateLabel": "Check-out datum",
                "dateBeforeWarning": "Check-out ligt voor check-in!",
                "selectStayTitle": "Selecteer uw verblijf",
                "selectStay": "Selecteer verblijf",
                "selectStayDisplay": "{{price}} € / dag voor {{count}} {{animalTypeLabel}}",
                "selectStayLineDisplay": "{{count}} {{animalTypeLabel}} in het '{{name}}'",
                "noAvailableStays": "Geen verblijven meer beschikbaar voor de opgegeven periode.",
                "choose_stay_type": "Kies verblijfstype",
                "updateDates": "Geef nieuwe check in/check out data in",
                "checkInHourTitle": "Geef het uur van de check-in op",
                "noCheckInHoursAvailable": "Er zijn geen check-in uren beschikbaar momenteel. U kan de reservatie verder afronden, {{tenantName}} zal u contacteren om het check-in uur af te spreken.",
                "checkOutHourTitle": "Geef het uur van de check-out op",
                "noCheckOutHoursAvailable": "Er zijn geen check-out uren beschikbaar momenteel. U kan de reservatie verder afronden, {{tenantName}} zal u contacteren om het check-out uur af te spreken.",
                "personalInformation": "Persoonlijke informatie",
                "firstName": "Voornaam",
                "street": "Straat",
                "houseNumber": "Huisnummer",
                "apartment": "Bus",
                "postalCode": "Postcode",
                "municipality": "Gemeente",
                "country": "Land",
                "gsm": "GSM",
                "email": "E-mail",
                "nameRequired": "Naam is een verplicht veld.",
                "firstNameRequired": "Voornaam is een verplicht veld.",
                "streetRequired": "Straat is een verplicht veld.",
                "houseNumberRequired": "Huisnummer is een verplicht veld.",
                "postalCodeRequired": "Postcode is een verplicht veld.",
                "municipalityRequired": "Gemeente is een verplicht veld.",
                "countryRequired": "Land is een verplicht veld.",
                "gsmRequired": "GSM is een verplicht veld.",
                "emailRequired": "E-mail is een verplicht veld.",
                "invalidEmail": "E-mail niet geldig.",
                "fetchPersonInfoError": "Persoon data ophalen mislukt.",
                "updatePersonInfoError": "Updaten persoon data mislukt.",
                "veterinaryContactInfo": "Contactinformatie Dierenarts",
                "practice": "Praktijk",
                "phoneNumber": "Telefoonnummer",
                "location": "Plaats",
                "practiceRequired": "Praktijk is een verplicht veld.",
                "veterinarianRequired": "Dierenarts is een verplicht veld.",
                "phoneNumberRequired": "Telefoonnummer is een verplicht veld.",
                "locationRequired": "Plaats is een verplicht veld.",
                "fetchVeterinaryError": "Dierenarts ophalen mislukt.",
                "updateVeterinaryError": "Updaten dierenarts mislukt.",
                "checkCatVaccinations": "Hoe controleer ik de vaccinaties van mijn kat?",
                "checkDogVaccinations": "Hoe controleer ik de vaccinaties van mijn hond?",
                "dog_vaccination_dhp": "DHP/DAP (hondenziekte/adenovirus/parvo)",
                "dog_vaccination_lepto": "Leptospirose (L4)",
                "dog_vaccination_kennel_cough": "Kennelhoest (Bordetella ± parainfluenza)",
                "dog_vaccination_rabies_optional": "Rabiës (optioneel)",
                "dog_medical_weightKg": "Gewicht (kg)",
                "dog_medical_sizeCategory": "Groottecategorie",
                "dog_size_xs": "XS",
                "dog_size_s": "S",
                "dog_size_m": "M",
                "dog_size_l": "L",
                "dog_size_xl": "XL",
                "dog_medical_hasMedication": "Neemt medicatie",
                "dog_medical_medicationNotes": "Medicatie opmerkingen",
                "dog_medical_allergies": "Allergieën",
                "dog_medical_femaleInHeat": "Teef loops",
                "dog_medical_lastHeatDate": "Laatste loopsheid",
                "dog_behavior_socialization": "Socialisatie",
                "dog_socialization_group_ok": "Groep OK",
                "dog_socialization_small_group_only": "Enkel kleine groep",
                "dog_socialization_solo_only": "Enkel solo",
                "dog_socialization_unknown": "Onbekend",
                "dog_behavior_reactiveOnLeash": "Reactief aan de leiband",
                "dog_behavior_resourceGuarding": "Resource guarding",
                "dog_behavior_separationAnxiety": "Verlatingsangst",
                "dog_behavior_houseTrained": "Zindelijk",
                "dog_behavior_biteHistory": "Bijtgeschiedenis",
                "dog_behavior_biteHistoryNotes": "Bijtgeschiedenis notities",
                "dog_behavior_muzzleRequired": "Muilkorf vereist",
                "dog_behavior_okWithCats": "OK met katten",
                "emergencyContactTitle": "Noodcontact bij niet bereikbaar",
                "fetchContactInfoError": "Persoon data ophalen mislukt.",
                "updateContactInfoError": "Updaten persoon data mislukt.",
                "reservationOverviewTitle": "Reservatie overzicht",
                "reservationNumber": "Reservatie nummer",
                "reservationPeriod": "Reservatie voor periode",
                "veterinaryPractice": "Dierenartsen praktijk",
                "reservationFor": "Reservatie voor",
                "selectedStay": "Geselecteerd voor verblijf",
                "XL": "Luxe- of Maine Coone verblijf",
                "STANDARD": "Standard stay",
                "reservationPrice": "Prijs van de reservatie",
                "serviceFeeIncluded": "Service fee inbegrepen",
                "advance": "Voorschot",
                "confirmReservation": "Bevestig uw reservatie",
                "fetchReservationError": "Reservatie overzicht ophalen mislukt.",
                "fetchPaymentLinkError": "Betaallink ophalen mislukt.",
                "paymentStatusFetchFailed": "Ophalen van de betaalstatus mislukt.",
                "reservationProcessingMessage": "We verwerken uw aanvraag.",
                "paymentOpenTitle": "Betaling niet uitgevoerd?",
                "paymentFailedTitle": "Betaling niet geslaagd!",
                "paymentCanceledTitle": "Betaling geannuleerd?",
                "paymentRetryText": "Probeer opnieuw",
                "redoPaymentButton": "Betaling opnieuw uitvoeren",
                "paymentSuccessTitle": "Betaling met succes uitgevoerd.",
                "paymentSuccessEmailNotice": "Een bevestigingsmail zal verzonden worden naar",
                "reservationOverviewButton": "Reservatie overzicht",
                "appointmentOverviewButton": "Afspraakoverzicht",
                "dayOverviewFetchFailed": "Dagoverzicht kon niet opgehaald worden.",
                "monthOverviewFetchFailed": "Maandoverzicht kon niet opgehaald worden.",
                "reservationManagementFetchFailed": "Ophalen van reservaties in overzicht mislukt.",
                "fetchCatError": "Kat ophalen mislukt.",
                "fetchPersonError": "Persoon ophalen mislukt.",
                "updateMyCatsError": "Mijn katten updaten mislukt.",
                "fetchStayInReservationFailed": "Ophalen van verblijf in reservatie mislukt.",
                "archiveAnimal": "Archiveer",
                "archiveCatConfirmTitle": "Kat archiveren?",
                "archiveCatConfirmMessage": "Weet je zeker dat je {{name}} wil archiveren? Gearchiveerde katten kunnen niet meer geselecteerd worden voor nieuwe reservaties.",
                "archiveCatSuccess": "Kat succesvol gearchiveerd.",
                "archiveCatFailed": "Archiveren van kat mislukt.",
                "itemsPerPage": "Rijen per pagina",
                "add_new_service_fee": "Nieuwe Servicevergoeding Toevoegen",
                "service_fees": "Servicekosten",
                "start_date": "Startdatum",
                "end_date": "Einddatum",
                "amount": "Bedrag",
                "edit": "Bewerken",
                "save_configuration": "Configuratie opslaan",
                "schedule_period": "Schema van {{startPeriod}} tot {{endPeriod}}",
                "day_of_week": "Dag van de Week",
                "add_check_in_hours": "Check-in Uren Toevoegen",
                "check_in_hours": "Check-in Uren",
                "add_check_out_hours": "Check-out Uren Toevoegen",
                "check_out_hours": "Check-out Uren",
                "none": "Geen",
                "error_fetching_schedules": "Fout bij het ophalen van schema's",
                "new_reservations_error": "Nieuwe reservaties kunnen niet opgehaald worden",
                "download_contracts_error": "Contracten downloaden mislukt",
                "validate_reservation_error": "Valideren van de nieuwe reservatie mislukt",
                "cancel_reservation_error": "Annuleren van de nieuwe reservatie mislukt",
                "awaiting_advance": "Wachten op voorschot",
                "mark_advance_received": "Markeer ontvangen",
                "mark_advance_received_error": "Bijwerken van voorschotstatus mislukt",
                "check_in": "Check-in",
                "check_out": "Check-out",
                "stay_types": "Verblijven",
                "service_name": "Dienstnaam",
                "price": "Prijs",
                "newest": "Nieuwste",
                "cats": "Kat(ten)",
                "update_reservation": "U staat op het punt reservatie aan te passen.",
                "countries": {
                    "Belgium": "België",
                    "France": "Frankrijk",
                    "Luxembourg": "Luxemburg",
                    "Netherlands": "Nederland"
                },
                "vacations": "Vakantie periodes",
                "add_new_vacations": "Vakantie toevoegen",
                "addReservation" : "Reservatie toevoegen",
                "error_fetching_vacations": "Vakantie periodes ophalen mislukt",
                "error_creating_vacations": "Het aanmaken van een nieuwe vakantie periode is mislukt",
                "error_deleting_vacations": "Verwijderen van vakantie periode mislukt",
                "searchFailure": "De zoekopdracht mislukt",
                "createdReservationSuccessful": "Reservatie aanmaken verwerkt",
                "createReservationFailed": "Reservatie aanmaken mislukt",
                "fetchAvailableStaysFailed": "Beschikbare verblijven ophalen mislukt",
                "checkAvailabilityFailed": "Reservatie beschikbaarheid ophalen mislukt",
                "checkAvailabilityCheckInHoursFailed": "Beschikbare check-in uren ophalen mislukt",
                "checkAvailabilityCheckOutHoursFailed": "Beschikbare check-out uren ophalen mislukt",
                "ownerName": "Eigenaar",
                "familie": "Alle katten",
                "selectCats": "Selecteer katten",
                "hour": 'Uur',
                "agreeTermsOfUse": "Ik ga akkoord met de servicekosten en de gebruiksvoorwaarden.",
                "termsOfUseRequired": "Je moet akkoord gaan met de gebruiksvoorwaarden.",
                "stays": "Verblijven",
                "stay": "Verblijf",
                "checkInCheckOut": "Check-in en check-out",
                "emails": "E-mails",
                "contracts": "Contracten",
                "description": "Beschrijving",
                "type": "Type",
                "stayNumber": "Verblijfsnummer",
                "guestsPerStay": "Gasten / verblijf",
                "staysConfig": "Configuratie verblijven",
                "scheduleFromTo": "Schema van %s tot %s",
                "drawCheckInHours": "Teken check-in uren",
                "drawCheckOutHours": "Teken check-out uren",
                "time": "Tijd",
                "monday": "Maandag",
                "tuesday": "Dinsdag",
                "wednesday": "Woensdag",
                "thursday": "Donderdag",
                "friday": "Vrijdag",
                "saturday": "Zaterdag",
                "sunday": "Zondag",
                "emailTemplates": "E-mailtemplates",
                "newTemplate": "Nieuwe template",
                "replyTo": "Reply-to",
                "subject": "Onderwerp",
                "daysBeforeReservation": "Dagen voor de reservatie",
                "preview": "Voorbeeld",
                "editTemplate": "Template bewerken",
                "emailType": "E-mailtype",
                "bodyTextHtml": "Body",
                "RESERVATION_CONFIRMATION": "Reservatiebevestiging",
                "RESERVATION_REMINDER": "Herinnering reservatie",
                "APPOINTMENT_CONFIRMATION": "Afspraakbevestiging",
                "APPOINTMENT_REMINDER": "Herinnering afspraak",
                "BOOKING_OPEN_DATE": "Boekingsdatum open",
                "SERVICE_FEE": "Servicekost",
                "suggestionsActive": "Suggesties actief",
                "tipAutocomplete": "Tip: Typ in HOOFDLETTERS (bv. CHE...) — ↑/↓ selecteren, Enter/Tab aanvullen. Beschikbaar:",
                "livePreview": "Livevoorbeeld",
                "newStay": "Nieuw verblijf",
                "editStay": "Verblijf bewerken",
                "noStaysMessage": "Nog geen verblijven. Klik op 'Nieuw verblijf'' om te beginnen.",
                "amountToCreate": "Aantal aan te maken",
                "from": "van",
                "to": "tot",
                "currentOccupancy": "Huidige bezetting",
                "numberOfAppointmentsToday": "Aantal afspraken vandaag",
                "ongoingReservations": "Lopende reservaties",
                "upcomingReservations": "Aankomende reservaties",
                "noCurrentReservations": "Geen lopende reservaties",
                "noUpcomingReservations": "Geen aankomende reservaties",
                "specialAttention": "Speciale aandacht voor",
                "noSpecialAttention": "Geen speciale aandacht",
                "yourLogoHere": "Uw logo hier",
                "checkInToday": "Check-in vandaag",
                "noCheckInToday": "Geen check-in vandaag",
                "checkOutToday": "Check-out vandaag",
                "noCheckOutToday": "Geen check-out vandaag",
                "january": "januari",
                "february": "februari",
                "march": "maart",
                "april": "april",
                "may": "mei",
                "june": "juni",
                "july": "juli",
                "august": "augustus",
                "september": "september",
                "october": "oktober",
                "november": "november",
                "december": "december",
                "noServicesFound": "Geen diensten gevonden",
                "noStaffFound": "Geen medewerkers gevonden",
                "configuratieparameters": "Configuratieparameters",
                "appointments": "Afspraken",
                "pageTitle": "Configuratieparameter",
                "startDate": "Startdatum",
                "endDate": "Einddatum",
                "editConfiguratieParameter": "Configuratieparameter bewerken",
                "loadFailed": "Laden mislukt",
                "saveFailed": "Opslaan mislukt",
                "attentionPoint": "Aandachtspunt",
                "unauthorizedBeheer": "Geen toestemming voor beheer",
                "validateReservationTitle":"Reservatie uit overzicht verwijderen",
                "validateReservationMessage":"Bent u zeker dat u de reservatie uit het overzicht wil verwijderen?",
                "cancelReservationTitle": "Reservatie annuleren",
                "cancelReservationMessage": "Bent u zeker dat u de reservatie wil annuleren?",
                // Status labels
                "statuses": {
                    "BOOKED": "Geboekt",
                    "BOOKED_AWAIT_ADVANCE": "In afwachting van voorschot",
                    "CANCELLED": "Geannuleerd"
                },
                // App-specifieke gegroepeerde berichten
                "attention": {
                    "save": {
                        "success": "Aandachtspunt opgeslagen",
                        "error": "Aandachtspunt opslaan mislukt"
                    }
                },
                "configuration": {
                    "save": {
                        "success": "Configuratie opgeslagen",
                        "error": "Configuratie opslaan mislukt"
                    }
                }
            }
        }
    },
    lng: "nl",
    fallbackLng: "nl",
    interpolation: {
        escapeValue: false,
    }
});

export default i18n;
